import { render, staticRenderFns } from "./business-apply.vue?vue&type=template&id=5b9701f4&scoped=true&"
import script from "./business-apply.vue?vue&type=script&lang=js&"
export * from "./business-apply.vue?vue&type=script&lang=js&"
import style0 from "./business-apply.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./business-apply.vue?vue&type=style&index=1&id=5b9701f4&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9701f4",
  null
  
)

export default component.exports